import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        background: "#FFFFFF",
        primary: "#1A1C24",
        /*primary: '#00A390',*/
        secondary: "#01B7A8",
        tertiary: "#495057",
        accent: "#13e5cc",
        error: "#f55a4e",
        info: "#00d3ee",
        success: "#01B7A8",
        warning: "#ffa21a"
      }
    }
  },
  icons: {
    iconfont: "mdi"
  }
});
